import * as types from './type';


export function changeTheme(data) {
    return {
      type: types.CHNAGE_THEME,
      payload: data,
    };
};
